var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',{attrs:{"code-description":_vm.codeDescription,"location":_vm.location}},[_c('span',{attrs:{"slot":"code"},slot:"code"},[_vm._v("\n    4"),_c('span',{staticClass:"text-error text-bold"},[_vm._v("0")]),_vm._v("4\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }